import _ from 'lodash'
import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import StandardReportBaseModel from 'scoreboard/reports/common/standard-report-base-model'

var ScorecardStructure = StandardReportBaseModel.extend({

	designer: false,

	defaults: function() {
		return _.extend(StandardReportBaseModel.prototype.defaults.apply(this), {
			subtype: 'scorecard-structure',
			label: i18n.get('report.scorecardStructureReport.title'),
			filters: {
				scorecardNodeIds: [{
					ancestorValues: []
				}]
			},
			columns: {
				columns: ['label']
			},
			showAbbreviatedValues: true
		})
	},

	validate: function(attributes, options) {
		var errors = {}
		if (_.isEmpty(attributes.label)) {
			errors.label = i18n.get('common.error.required', i18n.get('report.title'))
		}

		let ancestorId =_.get(attributes, 'filters.scorecardNodeIds[0].ancestorValues[0]', null)
		if (ancestorId == null) {
			errors.filters = i18n.get('common.error.mustSelect.scorecard-item')
		}

		return this.formatErrors(errors, options)
	},

	_doFetch: function(params) {
		return Backbone.ajax(params).then(function (res) {
			this.initialData = res.results
		}.bind(this))
	}

})

export default ScorecardStructure

ScorecardStructure.__filename__ = 'reports/scorecard-structure/scorecard-structure-model.js'
